var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotOk({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 21.7 22.2",
    style: {
      enableBackground: "new 0 0 21.7 22.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#EB3941;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21.3,11.8c-0.3,0.8-0.8,1.4-1.3,1.9c-0.6,0.4-1.3,0.7-2.2,0.8c-0.8,0.1-1.7,0.1-2.4,0.1h-0.3 c0,0,0,0.1,0.1,0.1c0.2,0.5,0.5,1.4,0.6,2.4c0.1,0.8,0,1.5-0.1,2.3c-0.2,0.8-0.5,1.4-0.9,1.8c-0.6,0.6-1.3,0.8-1.6,0.9 c-0.7,0.2-1.2,0.1-1.5-0.1c-0.5-0.3-0.7-0.8-0.9-1.2c-0.1-0.4-0.3-0.9-0.6-1.6l-0.1-0.3c-0.3-0.8-0.6-1.7-1-2.5 c-0.5-1.1-1-1.7-1.9-2.3H2c-0.3,0-0.6-0.1-0.8-0.4c-0.3-0.3-0.5-0.7-0.7-1.1C0.1,11.4,0,9.9,0,8.8c0-1.2,0.1-2.2,0.2-3.1 c0.2-0.8,0.4-1.6,0.7-2.3c0.2-0.6,0.6-1.1,0.9-1.5C1.9,1.8,1.9,1.7,2,1.6c0.2-0.2,0.5-0.3,0.7-0.3H9c0.1-0.1,0.2-0.2,0.4-0.2L9.5,1 c0.3-0.2,0.6-0.4,1-0.6c0.5-0.2,1.2-0.3,2.1-0.4C13.1,0,13.8,0,14.4,0c0.5,0,0.9,0,1.3,0c1.2,0.1,2,0.2,2.7,0.5 c0.9,0.4,1.5,0.9,1.9,1.8C20.6,3,20.9,4,21.2,5.5c0.1,0.7,0.4,2.4,0.5,3.8C21.7,10.3,21.6,11.1,21.3,11.8L21.3,11.8z M19.7,9.3 c0-0.9-0.2-2.2-0.5-3.5c-0.2-0.9-0.4-2-0.7-2.6c-0.2-0.5-0.5-0.7-0.8-0.8c-0.5-0.2-1.1-0.3-2.1-0.4c-0.9,0-2,0-2.9,0 c-0.9,0.1-1.4,0.2-1.6,0.2c-0.2,0.1-0.2,0.1-0.5,0.3l-0.1,0.1C10.3,2.8,10.1,3,9.9,3.1C9.7,3.3,9.6,3.4,9.4,3.5 C9.2,3.8,9,4.2,8.8,4.6C8.6,5.2,8.4,5.8,8.3,6.5C8.1,7.2,8.1,8.1,8.1,9.2c0,0.5,0,2.1,0.4,2.9c0,0.1,0.1,0.1,0.1,0.1 c1.3,0.9,2,1.8,2.6,3.2c0.4,0.9,0.8,1.9,1.1,2.7l0.1,0.3c0.2,0.7,0.4,1.2,0.6,1.6v0c0.2-0.1,0.5-0.2,0.6-0.3 c0.1-0.2,0.3-0.4,0.4-0.8c0.1-0.5,0.2-1.1,0.1-1.6c-0.1-0.7-0.4-1.5-0.5-1.9c-0.2-0.5-0.4-0.8-0.5-1.1l-0.1-0.1 c-0.1-0.2-0.3-0.7,0-1.2c0.3-0.5,0.9-0.5,1.1-0.5s0.6,0,1.1,0h0.4c0.6,0,1.4,0.1,2.1,0c0.5-0.1,0.9-0.2,1.2-0.4s0.5-0.6,0.7-1 C19.6,10.8,19.7,10.3,19.7,9.3L19.7,9.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotOk);
export default __webpack_public_path__ + "static/media/not-ok.b5ce7e6430e7ef3ce71ea82403e72c90.svg";
export { ForwardRef as ReactComponent };